import CONFIG from '../config/config';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';

export type MoneyInResponse = {
  [date: string]: number;
};

export type SalesRepresentativeMoneyResponse = {
  [employeeId: string]: number;
};

export type SalesRepresentativeCountResponse = {
  [employeeId: string]: number;
};

export type RankingOfSoldItemsResponse = {
  [itemName: string]: number;
};

export type SalesSummaryResponse = {
  totalSales: number;
  totalMoney: number;
};

export type PaymentInstalmentsResponse = {
  depositedAmount: number;
  depositedCount: number;
  pendingAmount: number;
  pendingCount: number;
};

export type TimeRangeParams = {
  startTime?: string;
  endTime?: string;
};

const qs = (params: TimeRangeParams) => {
  const searchParams = new URLSearchParams();
  if (params.startTime) searchParams.append('startTime', params.startTime);
  if (params.endTime) searchParams.append('endTime', params.endTime);
  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};

const SalesInsightsAPI = {
  getMoneyInPerDay: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<MoneyInResponse>(
      `/v1/statistics/sales/money-in-per-day${qs({ startTime, endTime })}`
    ),

  getMoneyInPerMonth: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<MoneyInResponse>(
      `/v1/statistics/sales/money-in-per-month${qs({ startTime, endTime })}`
    ),

  getMoneyPerSalesRepresentative: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<SalesRepresentativeMoneyResponse>(
      `/v1/statistics/sales/money-per-sales-representative${qs({ startTime, endTime })}`
    ),

  getSalesPerSalesRepresentative: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<SalesRepresentativeCountResponse>(
      `/v1/statistics/sales/sales-per-sales-representative${qs({ startTime, endTime })}`
    ),

  getRankingOfSoldItems: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<RankingOfSoldItemsResponse>(
      `/v1/statistics/sales/ranking-of-sold-items${qs({ startTime, endTime })}`
    ),

  getSalesSummary: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<SalesSummaryResponse>(
      `/v1/statistics/sales/summary${qs({ startTime, endTime })}`
    ),

  getAverageSalePrice: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<{ averageSalePrice: number; count: number }>(
      `/v1/statistics/sales/summary/average-sale-price${qs({ startTime, endTime })}`
    ),

  getAverageDressSalePrice: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<{ averageDressSalePrice: number; count: number }>(
      `/v1/statistics/sales/summary/average-dress-sale-price${qs({ startTime, endTime })}`
    ),

  getPaymentInstalments: ({ startTime, endTime }: TimeRangeParams) =>
    APIClient(CONFIG.API_ENDPOINT).get<PaymentInstalmentsResponse>(
      `/v1/statistics/sales/summary/payment-instalments${qs({ startTime, endTime })}`
    ),
};

export default SalesInsightsAPI;
